var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C4.44772 0 4 0.447715 4 1H1C0.447715 1 0 1.44772 0 2C0 2.55228 0.447715 3 1 3H11C11.5523 3 12 2.55228 12 2C12 1.44772 11.5523 1 11 1H8C8 0.447715 7.55228 0 7 0H5ZM0.16781 7.27514C0.000806652 6.07271 0.93483 5 2.14879 5H9.85182C11.0658 5 11.9998 6.07271 11.8328 7.27514L10.8606 15.2751C10.7233 16.2639 9.87785 17 8.8796 17H3.12102C2.12276 17 1.27736 16.2639 1.14003 15.2751L0.16781 7.27514ZM9.78372 7.56032C9.81992 7.26245 9.58744 7 9.28738 7L2.71324 7C2.41317 7 2.18069 7.26245 2.21689 7.56032L3.06758 14.5603C3.09808 14.8113 3.31112 15 3.56393 15H8.43668C8.6895 15 8.90253 14.8113 8.93303 14.5603L9.78372 7.56032Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteButton);
export default __webpack_public_path__ + "static/media/deleteButton.cbaa5455.svg";
export { ForwardRef as ReactComponent };